import { TMessageSchema } from '../../types/messages';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { TMessagesMap } from '../../utils/messageUtils';

export enum ESendMessageActionTypes {
  SetFailed = 'sendMessage/failed',
  SetSuccess = 'sendMessage/success',
  SetPending = 'sendMessage/pending',
  SetDelete = 'sendMessage/delete',
  SetFirstMessageSuccess = 'sendMessage/firstMessageSuccess',
}

export interface ISendMessagePayload {
  message: TMessageSchema;
  messageId: string;
  messagesMap: TMessagesMap;
}

export interface IDeleteMessagePayload {
  chatId: string;
  messageId: string;
  messagesMap: TMessagesMap;
}

export interface ISendFirstMessagePayload {
  message: TMessageSchema;
  messagesMap: TMessagesMap;
}

export type TSendMessageActions =
  | ITypedReduxAction<ESendMessageActionTypes.SetFailed, ISendMessagePayload>
  | ITypedReduxAction<ESendMessageActionTypes.SetSuccess, ISendMessagePayload>
  | ITypedReduxAction<ESendMessageActionTypes.SetPending, ISendMessagePayload>
  | ITypedReduxAction<ESendMessageActionTypes.SetDelete, IDeleteMessagePayload>
  | ITypedReduxAction<ESendMessageActionTypes.SetFirstMessageSuccess, ISendFirstMessagePayload>;
